import { useLocales } from 'api/hooks/useGetLocalesFormSlug'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

interface Props {
  setLocale: (lng: string) => void
}

export const LanguageSwitcherV2: React.FC<Props> = ({ setLocale }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [showDropdown, setShowDropdown] = React.useState(false)
  const { locales } = useLocales()

  const { i18n } = useTranslation()
  const current = i18n.language

  const queryHideReservation = searchParams.get('hide_reservation')

  const handleLocale = (l: string) => {
    let params = {}

    if (queryHideReservation) {
      params = { hide_reservation: queryHideReservation }
    }

    setSearchParams({ ...params })
    setLocale(l)
    setShowDropdown(false)
  }

  if (!locales) {
    return <></>
  }

  return (
    <div className="flex justify-center text-[12px] relative">
      <button onClick={() => setShowDropdown(!showDropdown)} className="flex items-center gap-1">
        {locales.find((l) => l === current)?.toUpperCase() || current.toUpperCase().split('-')[0]}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 6.75L8 9.25L11 6.75" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
      <div
        className={`fixed ${showDropdown ? 'block' : 'hidden pointer-events-none'} top-0 left-0 w-full h-full cursor-pointer`}
        onClick={() => setShowDropdown(false)}
      ></div>
      <div
        className={`absolute ${showDropdown ? 'flex' : 'hidden pointer-events-none'} z-40 top-full mt-2 left-1/2 -translate-x-1/2 bg-primary border border-tertiary text-tertiary flex-col items-center border-b-0`}
      >
        {locales.map((l) => {
          if (!l) return <></>
          return (
            <button
              key={l}
              onClick={() => handleLocale(l)}
              className={`px-4 py-2 border-b border-tertiary uppercase ${current === l && 'underline'}`}
            >
              {l}
            </button>
          )
        })}
      </div>
    </div>
  )
}
